module.exports = __webpack_public_path__ + "static/media/icon_formatting.8599d98c.svg";